import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
// import axios from 'axios';
import axios from '../../hooks/fetchWithAuth';
import Button from '@mui/material/Button';
import config from '../../config';
import getCookie from '../../hooks/getCookie';

const DetailBox = styled('div')(({ theme }) => ({
  backgroundColor: '#313940',
  boxShadow: theme.shadows[5],
  padding: theme.spacing(3),
  color: 'white',
  maxWidth: 300,
  minWidth: 280,
  overflowY: 'auto',
}));

const Checklist = ({ anchorEl, onClose, selectedCard, handleSetNewTodos, fetchLogs }) => {
  const [newItem, setNewItem] = useState('');

  const backendIp = config.backend_ip;
  const nameComplete = getCookie("nome_completo");
  const username = getCookie("username");
  const sessionId = getCookie("session_id");

  const handleAddChecklist = async () => {
    if (newItem.trim() !== '') {
      try {
        const response = await axios.put(`${backendIp}/api/board/ti/add_checklist`, {
          card_id: selectedCard.id,
          checklist_title: newItem,
          name_complete: nameComplete,
          user: username,
          session_id: sessionId
        });
        setNewItem('');
        // Informa para o SideMenu que uma nova checklist foi adicionada
        fetchLogs(selectedCard.id);
        handleSetNewTodos();
      } catch (error) {
        return null;
      }
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleAddChecklist();
    }
  };

  const handleClose = () => {
    onClose();
  };

  const open = Boolean(anchorEl);

  return (
    <Box sx={{ width: '100%', position: 'relative' }}>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <DetailBox>
          <>
            <p className='titulo-checklist paragraph-members'>Adicionar checklist</p>
            <TextField
              placeholder='Título do checklist'
              variant="outlined"
              value={newItem}
              onChange={(e) => setNewItem(e.target.value)}
              onKeyDown={handleKeyDown}
              id="outlined-size-small"
              size="small"
              sx={{
                width: '280px',
                marginRight: '10px',
                borderRadius: '6px',
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'var(--textfield-bg-color, #fff)',
                  color: 'var(--textfield-text-color, #000)',
                  '& fieldset': {
                    borderColor: 'var(--textfield-border-color, #ccc)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'var(--textfield-hover-border-color, #aaa)',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'var(--textfield-focus-border-color)',
                  },
                },
                '& .MuiInputLabel-root': {
                  color: 'var(--textfield-label-color, #000)',
                },
                '& .Mui-focused .MuiInputLabel-root': {
                  color: 'var(--textfield-label-focus-color)',
                },
                '& .MuiInputBase-input': {
                  color: 'var(--textfield-text-color, #000)',
                },
              }}
            />
            <Button
              onClick={handleAddChecklist}
              className='button-checklist'
            >
              Adicionar
            </Button>
          </>
        </DetailBox>
      </Popover>
    </Box>
  );
};

export default Checklist;
